import React from "react";
import { DisplayText } from "@shopify/polaris";
import SupportBooking from "../../components/Calendy/SupportBooking";
import MCPFooterHelp from "../../components/common/MCPFooterHelp";

const BookDemoContainer = () => (
  <div className="row book-demo-container">
    <div className="cl-12">
      <div className="text-align-center mt-15">
        <DisplayText size="large">Book a demo</DisplayText>
      </div>
      <p className="book-demo-subtitle">
        Schedule a call with our team to get help with setup and pricing.
      </p>
      <div className="book-demo-calendly">
        <SupportBooking />
      </div>
      <MCPFooterHelp />
    </div>
  </div>
);

export default BookDemoContainer;
